module.exports = __webpack_public_path__ + "static/media/area_3_image.0abd0fb0.jpg";